import store from "@/store";

const routes = [{
    path: "/sales/packing-list/:id",
    name: "salespacking",
    component: () => import('@/views/main/modules/Sales/PackingList/PackingListGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Delivery Receipts',
        service: 0,
    }
}]

export default routes;
